// jQuery(document).ready(function($) {
//     if(!is_dev) {
//         return;
//     }
//     add_company()
// });
function add_company(afterAdd) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/company/add',
        onOpen: function (elm, popup) {
            elm.find('[name="name"]').cocSearch();
            elm.find('[data-company-selector]').companySelector();

            elm.find('[name=coc_no]').keyup(function() {
                const input = $(this);
                const coc = input.val();
                if (isNaN(coc)) return;
                if (coc.length < 8) return;
                if (input[0].fetch) input[0].fetch.abort();
                input[0].fetch = $.get('/coc-api', { coc }, function(data) {
                    if (data) {
                        const result = data[0] || data;
                        const mapping = {
                            handelsnaam: 'input:visible[name="name"]',
                            postcode: 'input:visible[name*="postal_code\\]"]',
                            huisnummer: 'input:visible[name*="street_no\\]"]',
                            huisnummertoevoeging: 'input:visible[name*="street_no_adding\\]"]',
                            plaats: 'input:visible[name*="city\\]"]',
                            straat: 'input:visible[name*="street\\]"]',
                        }
                        Object.keys(mapping).forEach((key) => {
                            const input = elm.find(mapping[key]);
                            const value = result[key];
                            input.val(value);
                        });
                        elm.find('input:visible[name*="country_code\\]"]').val('NL');
                    }
                });
            });

            elm.find('form').ajaxFormSubmit(function(data){
                reload_location_if_needed(true);
                if (!document.closeWindow) {
                    open_new_object(view_company, data)
                }
                if(afterAdd) {
                    $('body').doneLoading();
                    afterAdd(data, elm, popup);
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                var errors = JSON.parse(xhr.responseText);
                if(errors.client_id && errors.client_id.toString().split('bezet').length > 1) {
                    //Increment the client id and retry
                    var input = elm.find('input[name="client_id"]');
                    var val = input.val();
                    if(parseInt(val) > 0) {
                        input.val(parseInt(val)+1);
                        elm.find('form').submit();
                    }
                }
                if($('.squde-flash').length == 0) {
                    squde_flash("Er ging iets mis bij het opslaan.", "alert");
                }
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function delete_company(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);
    custom_delete_with_confirmation("/company/delete",id,"Weet u zeker dat u \""+name+"\" wilt verwijderen?",'company');

    return false;
}
function view_company(id, vars) {
    const $ = jQuery.noConflict();

    if(vars !== undefined && typeof vars === "function") {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/company/view/'+id,
        onOpen: function(elm, popup) {
            elm.find('[data-company-selector]').companySelector();
            initiate_contact_company_field(elm);
            initiate_evaluation_statistics(elm);
            load_custom_style_interface(elm, popup);
            initiate_custom_product_validation_logic(id, elm);
            initiate_customizations_logic(id, elm);

            init_documents_filters(elm);

            elm.find('form').ajaxFormSubmit(function(data, form){
                updateObject('company', id);

                $('body').doneLoading();
                squde_reload_for_flashes();
                if (document.closeWindow) popup.close();
                if(vars && vars.callback) {
                    vars.callback(data, elm, popup);
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function initiate_custom_product_validation_logic(companyId, elm) {
    const $ = jQuery.noConflict();
    const wrapper = elm.find('.product-template-validation-wrapper');

    const fillWrapper = async () => {
        if (wrapper.length === 0 || !wrapper.closest('.sub-screen-wrapper').is(':visible')) return;

        const html = await $.get(`/companies/${companyId}/loadCustomCourseProductLineValidation`);
        wrapper.html(html);
    }

    fillWrapper();

    if (!wrapper.length) return;
    elm.unbind('openTab.customProductValidation').bind('openTab.customProductValidation', function(e, tab) {
        if (tab !== 'contact_info') return;
        fillWrapper();
    });
}

function initiate_customizations_logic(companyId, elm) {
    const $ = jQuery.noConflict();
    const wrapper = elm.find('.sub-screen-wrapper#customizations');
    if (wrapper.length === 0) return;

    elm.unbind('openTab.customizations').bind('openTab.customizations', async function(e, tab) {
        if (tab !== 'customizations') return;
        const screenContainer = wrapper.find('.customizations-screen-container');

        const html = await $.get(`/companies/${companyId}/customizations/getTab`);
        screenContainer.html(html);

        screenContainer.find('textarea').customTextarea();

        screenContainer.find('form').ajaxFormSubmit(function(data) {
            squde_reload_for_flashes();
            reload_location_if_needed(document.closeWindow);
        });

    });
}

function initiate_contact_company_field(elm) {
    const $ = jQuery.noConflict();
    const selector = elm.find('[data-contact-selector]');
    selector.contactSelector();

    const contactPersonInfo = elm.find('.contact-person-info');

    const handleContactChange = async () => {
        const val = parseInt(selector.val());
        if (isNaN(val)) {
            contactPersonInfo.hide();
            return;
        }
        const contact = (await selector.getObject())[0];

        contactPersonInfo.toggle(!!contact);

        if (!contact) return;

        if (parseInt(selector.val()) !== contact.id) {
            return;
        }

        const companyLink = $('<a />');
        companyLink.click(function() {
            view_company(contact.company_id)
            return false;
        })
        companyLink.text(contact.company.name);

        contactPersonInfo.find('.contact-company').html(companyLink);
        const phoneNumbers = [
            contact.mobile_phone,
            contact.phone,
        ].filter((number) => {
            if (!number) return false;
            return number.trim().length > 0;
        })
            .map((number) => {
                return `<a href="tel:${number}">${number}</a>`;
            });
        if (phoneNumbers.length === 0) {
            phoneNumbers.push('Geen telefoonnummer');
        }
        contactPersonInfo.find('.contact-phone-numbers').html(phoneNumbers.join(', '));


        const emailAddresses = [
            contact.email,
        ].filter((email) => email.trim().length > 0)
            .map((email) => {
                return `<a href="mailto:${email}">${email}</a>`;
            });
        if (emailAddresses.length === 0) {
            emailAddresses.push('Geen e-mailadres');
        }
        contactPersonInfo.find('.contact-email').html(emailAddresses.join(', '));
    }
    handleContactChange();
    selector.unbind('change.contact').bind('change.contact', handleContactChange);
}


/**
 * Returns the contact-options for a contact. Usually displayed by a phone-icon.
 * It lists all of the possible ways to get in touch with the given contact.
 *
 * @param id
 * @returns {boolean}
 */
function view_company_contact_options(id) {
    var $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/company/getContactOptions/'+id,
        size: 'medium',
        onOpen: function (elm, popup) {
        }
    });
    return false;
}

/**
 * Almost does the same as deleting, only sets enabled to 0
 *
 * @param id
 * @param name
 * @returns {boolean}
 */
function disable_company(id, name) {
    const $ = jQuery.noConflict();
    name = decodeURI(name);

    confirm("Weet u zeker dat u \""+name+"\" wilt deactiveren?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/company/disable",
            data: {id:id},
            type: "POST",
            success: function(data) {
                $('[data-object-type=\'company\'][data-id=\''+id+'\'').remove();
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                console.log({ e });

                try {
                    const error = JSON.parse(e.responseText);
                    const errorData = JSON.parse(error.error);
                    const preventors = errorData.disablePreventors;
                    if (preventors) {
                        showDisablePreventors(preventors);
                    }
                } catch (e) {
                    squde_flash("Er ging helaas iets mis.", "alert");
                }
            }
        });
    });
    return false;
}

/**
 * Almost the same as disabling, but enabling
 *
 * @param id
 * @param name
 * @returns {boolean}
 */
function enable_company(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);

    $('body').isLoading('dark');
    $.ajax({
        url: "/company/disable",
        data: {id:id},
        type: "POST",
        success: function(data) {
            var row = $('[data-object-type=\'company\'][data-id=\''+id+'\'');
            row.find('.visual-icon-activate').removeClass('visual-icon-activate').addClass('visual-icon-deactivate');
            row.find('.visual-icon-deactivate').parent().attr('onclick', 'return disable_company('+id+',"'+name+'");');
            $('body').doneLoading();
        },
        error: function(e) {
            $('body').doneLoading();
            try {
                const error = JSON.parse(e.responseText);
                const errorData = JSON.parse(error.error);
                const preventors = errorData.disablePreventors;
                if (preventors) {
                    showDisablePreventors(preventors);
                }
            } catch (e) {
                console.log({ e });
            }
            squde_flash("Er ging helaas iets mis.", "alert");
        }
    });
    return false;
}

function get_company(id) {
    const $ = jQuery.noConflict();

    return new Promise((resolve, reject) => {
        $.ajax({
            url: '/company/' + id,
            success: resolve,
            error: reject
        })
    })
}

(function ( $ ) {
    $.fn.cocSearch = function(val, params) {
        // temporarily disabled because of being disabled by the coc
        return;
        $(this).each(function() {
            const elm = $(this);
            elm.bind('keyup.coc focus.coc', function() {
                if (elm[0].cocAjax) {
                    elm[0].cocAjax.abort();
                }
                $('.coc-results-wrapper').remove();
                elm[0].cocAjax = $.get('/coc-api', { search: elm.val() }, function(data) {
                    if (data.length === 0) return;

                    const width = elm.outerWidth();
                    const left = elm.offset().left;
                    const top = elm.offset().top + elm.outerHeight();

                    const cocResults = $('<div class="coc-results-wrapper" />');
                    cocResults.css({
                        width,
                        top,
                        left,
                    })
                    const ul = $('<ul />');
                    cocResults.append(ul);

                    data.forEach((result) => {
                        const li = $('<li />');
                        li.html(`<b>${result.handelsnaam}</b><br />
                                 <span>${result.dossiernummer}</span>`);
                        if (result.straat && result.postcode && result.plaats) {
                            li.append(`<br /><span>${result.straat} ${result.huisnummer}${result.huisnummertoevoeging}, ${result.postcode} ${result.plaats}</span><br />`);
                        }
                        ul.append(li);
                        li.click(function() {
                            elm.parents('form').find('input[name="coc_no"]').val(result.dossiernummer).trigger('keyup');
                            $('.coc-results-wrapper').remove();
                        });
                    });

                    $('body').prepend(cocResults);
                });
            }).bind('blur.coc', function() {
                setTimeout(() => {
                    $('.coc-results-wrapper').remove();
                }, 500);
            });
        });
        return this;
    };

}( jQuery ));
